// src/services/tags.js
export const tagTypes = ['Client', 'Appointment','Patient', 'Contract', 'Caregiver', 'Note', 'Billing'];
